export const title = 'Resume - Przemysław Zalewski - Ciunkos'
export const description =
  'Senior full-stack engineer from Wrocław, Poland: 15+ years shipping software, React since 2017, TypeScript, Node.js, C#/.NET and AI agents. Available from November 2026.'

export default {
  title,
  description
}
